import type { ReactNode } from "react";
import { Children, cloneElement, createRef, useState } from "react";
import Icon from "../Icon";
import { BaseProps } from "./items/BaseProps";
import { setRef } from "../../utils/SetRef";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";
import "../../styles/actionbar/category.css";

export { ActionBarCategory, isDescendant };

type Props = {
  order?: number;
  title: string;
  stretch?: boolean;
  /**
   * If set, all children are marked as disabled
   */
  disableChildren?: boolean;
  children: ReactNode;
  /**
   * Indicates that a child item is selected
   */
  underlined?: boolean;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};

const isDescendant = (parent: HTMLElement, child: HTMLElement) => {
  let node = child.parentNode;
  while (node != null) {
    if (node == parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

const ActionBarCategory = (props: Props) => {
  const categoryRootRef = createRef<HTMLDivElement>();
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("");

  let className = "actionBarCategory ";
  if (props.stretch) {
    className += "stretcher ";
  }
  if (props.underlined) {
    className += "underlined ";
  }
  if (props.disableChildren) {
    className += "disabled ";
  } else {
    // FIXME: figure out if all items disabled
    // className += `${props.items.filter(i => !i.disabled).length == 0 ? 'disabled' : ''}`;
    //
  }
  const children = Children.map(props.children, (child, index) => {
    if (!child) return;
    let newProps: Partial<BaseProps> = {
      subCategory: true,
    };
    if (props.disableChildren) {
      newProps = { ...newProps, disabled: true };
    }
    //@ts-ignore
    return cloneElement(child, newProps);
  });
  return (
    <div
      {...props.tProps}
      ref={(r) => {
        setRef(categoryRootRef, r);
        if (props.tProps) {
          setRef(props.tProps.ref, r);
        }
      }}
      className={className}
      onMouseEnter={(e) => {
        setOpen(true);
        if (props.tProps && props.tProps.onMouseEnter)
          props.tProps.onMouseEnter();
      }}
      onMouseLeave={(e) => {
        if (!isDescendant(e.currentTarget, e.relatedTarget as HTMLElement)) {
          setOpen(false);
        }
        if (props.tProps && props.tProps.onMouseLeave)
          props.tProps.onMouseLeave();
      }}
    >
      <div className={"actionBarCategoryText"}>
        <span data-abi-title>{props.title}</span>
        <Icon altText={""} icon={"chevron-down"} />
        {/* create hidden span that will force the width of the category text to be as wide as the widest element */}
      </div>
      <ul
        className={`items ${open ? "open" : ""}`}
        style={{ minWidth: categoryRootRef.current?.clientWidth ?? "inherit" }}
      >
        {children}
      </ul>
    </div>
  );
};
